import {NgModule} from '@angular/core'
import {ProcessNavbarComponent} from './process-navbar.component'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {RouterModule} from '@angular/router'
import {ProcessCloseConfirmationComponent} from './process-close-confirmation.component'
import {PipesModule} from '../../pipes/pipes.module'
import {ProcessService} from './process.service'
import {TranslocoModule} from '@ngneat/transloco'
import {CommonModule, NgOptimizedImage} from '@angular/common'
import {DialogModule} from '../../../craft/dialog/dialog.module'
import {ProgressStepperComponent} from '../../../craft/progress-steps/progress-stepper.component'

@NgModule({
  declarations: [ProcessNavbarComponent, ProcessCloseConfirmationComponent],
  imports: [
    FontAwesomeModule,
    RouterModule,
    PipesModule,
    TranslocoModule,
    CommonModule,
    NgOptimizedImage,
    DialogModule,
    ProgressStepperComponent,
  ],
  exports: [ProcessNavbarComponent, ProcessCloseConfirmationComponent],
  providers: [ProcessService],
})
export class ProcessNavbarModule {}
